import {Injectable} from '@angular/core';
import {Http, RequestOptions, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {environment} from 'environment';
import {Badge} from 'shared/models/badges/badge';
import {IBadgesOverviewRepository} from './badges-overview.repository.interface';

@Injectable()
export class BadgesOverviewHttpRepository implements  IBadgesOverviewRepository {

  constructor(private http: Http) { }

  public getBadges(): Observable<Array<Badge>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(environment.badges, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public deleteBadge(id: string): Observable<void> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.delete(`${environment.badges}/${id}`, options)
      .map((response: Response) => {
        return;
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/badges/badges-overview/repositories/badges-overview.repository.http.ts